const testIds = {
  total: "total",
};

export default testIds;
